import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from "../theme";
import { Icon } from "./Icon";
const IconGrid = styled.div `
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 20px;
  padding: 20px;
`;
const IconItem = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: white;
  transition: all 0.2s ease;

  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transform: translateY(-2px);
  }
`;
const IconWrapper = styled.div `
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
`;
const IconNameText = styled.span `
  font-size: 12px;
  color: #666;
  text-align: center;
  word-break: break-word;
  line-height: 1.2;
`;
// All available icon names from the Icon component
export const ALL_ICON_NAMES = [
    "admin",
    "alert",
    "clock",
    "cloud",
    "dots",
    "down",
    "download",
    "download-cloud",
    "upload-cloud",
    "drag",
    "duplicate",
    "editor-bold",
    "editor-email",
    "editor-headline-main",
    "editor-headline-secondary",
    "editor-image",
    "editor-new-question",
    "editor-link",
    "editor-new-slide",
    "editor-new-text",
    "editor-ordered-list",
    "editor-small-text",
    "editor-unordered-list",
    "editor-video",
    "email",
    "left",
    "message",
    "message-alt",
    "notification",
    "options-checkboxes",
    "options-date",
    "options-file-upload",
    "options-dropdowns",
    "options-multiple-choice",
    "options-paragraph",
    "options-short-answer",
    "options-time",
    "pencil",
    "phone",
    "right",
    "search",
    "sort-down",
    "sort-up",
    "trash",
    "up",
    "user",
    "check-filled",
    "index",
    "check-circle",
    "add",
    "lock",
    "info",
    "a-letter",
    "camera",
    "text-size",
    "clear",
    "pause",
    "flag-alt",
    "flag-outlined",
    "house",
    "back",
    "close",
    "check",
    "audio",
    "reports",
    "permissions-share-access",
    "permissions",
    "compare",
    "analytics",
    "export",
    "overview",
    "trash-2",
    "arrow-up",
    "calendar",
    "flag",
    "arrows",
    "file-pdf",
    "arrows-cw",
    "town-hall",
    "grid",
    "cancel",
    "minus-1",
    "adjust",
    "na",
    "circle-empty",
    "angle-double-right",
    "block",
    "flash",
    "flash-outline",
    "help-circled-alt",
    "arrow-left",
    "arrow-down",
    "star",
    "star-empty",
    "th-large",
    "building",
    "building-filled",
    "th-large-outline",
    "th-list",
];
export const IconGallery = () => (_jsx(IconGrid, { children: ALL_ICON_NAMES.map(iconName => (_jsxs(IconItem, { children: [_jsx(IconWrapper, { children: _jsx(Icon, { name: iconName, size: 24 }) }), _jsx(IconNameText, { children: iconName })] }, iconName))) }));
